/** @format */
import { popularBrands } from '@toucan/config/brands';

import { TaxonomyTerm } from '@toucan/types/mpbx/taxonomy';

export const getFilteredBrandsByShortList = (
    brands?: TaxonomyTerm,
    shortList = popularBrands
) => {
    if (!brands) {
        return brands;
    }

    return {
        ...brands,
        children: shortList
            .map((brand) => {
                return brands.children.find(({ id }) => id === brand.id);
            })
            .filter(Boolean) as TaxonomyTerm[],
    };
};
